import { IDataScope } from './IDataScope';
import { PeriodPreference, ReportPreference } from '../../admin/models/ReportPreference';

export interface IGlimpseUser {
  userId: number;
  firstName: string;
  lastName: string;
  email: string;
  roles: string[];
  customers: IDataScope[];
  username: string;
  rank: number;
  phoneNumber: string;
  subscriptions: string[];
  reportsPref: ReportPreference;
  timePref: string;
  emailPref: boolean;
  smsPref: boolean;
  alertsPref: boolean;
  periodsPref: PeriodPreference[];
  lostItemsPref: boolean;
  lastOnboardedAt: Date;
}

export function UserHasPushSubscription(user: IGlimpseUser, sub: PushSubscription): boolean {
  return user?.subscriptions && sub?.endpoint && user?.subscriptions.some(s => s.includes(sub.endpoint));
}
